import { render, staticRenderFns } from "./IconSvgGzip.vue?vue&type=template&id=9cb2ae2e&scoped=true&"
import script from "./IconSvgGzip.vue?vue&type=script&lang=js&"
export * from "./IconSvgGzip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cb2ae2e",
  null
  
)

export default component.exports